<form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" *ngIf="!success">
    <h1 [innerHTML]="translationPrefix + '.title' | translate"></h1>
    <p class="large" [innerHTML]="translationPrefix + '.intro' | translate"></p>
    <div class="change-password-wrapper" *ngIf="user$ | async as user">
        <div class="form-group label">
            <label class="label" [innerHTML]="translationPrefix + '.email' | translate"></label>
            <label for="username"
                ><strong>{{ user.email }}</strong></label
            >
        </div>

        <div
            class="form-group"
            [class.active]="hasFocusCurrentPassword || hasValue(f.currentPassword)"
            [class.hasvalue]="!hasFocusCurrentPassword && hasValue(f.currentPassword)"
        >
            <label
                for="currentPassword"
                [class.active]="hasFocusCurrentPassword || hasValue(f.currentPassword)"
                [class.hasvalue]="!hasFocusCurrentPassword && hasValue(f.currentPassword)"
            >
                <span class="labelcontent"><span [innerHTML]="translationPrefix + '.currentPassword' | translate"></span></span>
                <input
                    formControlName="currentPassword"
                    id="currentPassword"
                    (focus)="hasFocusCurrentPassword = true"
                    (blur)="hasFocusCurrentPassword = false"
                    type="password"
                />
            </label>
            <div *ngIf="submitted && (f.currentPassword.errors || showMessage)" class="invalid-feedback">
                <div
                    *ngIf="f.currentPassword.errors && f.currentPassword.errors.required"
                    [innerHTML]="translationPrefix + '.currentPasswordRequired' | translate"
                ></div>
                <div
                    *ngIf="f.currentPassword.errors && f.currentPassword.errors.validation"
                    [innerHTML]="translationPrefix + '.emailFormat' | translate"
                ></div>
            </div>
        </div>

        <div
            class="form-group"
            [class.active]="hasFocusNewPassword || hasValue(f.newPassword)"
            [class.hasvalue]="!hasFocusNewPassword && hasValue(f.newPassword)"
        >
            <label
                for="newPassword"
                [class.active]="hasFocusNewPassword || hasValue(f.newPassword)"
                [class.hasvalue]="!hasFocusNewPassword && hasValue(f.newPassword)"
            >
                <span class="labelcontent"><span [innerHTML]="translationPrefix + '.newPassword' | translate"></span></span>
                <input
                    formControlName="newPassword"
                    id="newPassword"
                    (focus)="hasFocusNewPassword = true"
                    (blur)="hasFocusNewPassword = false"
                    type="password"
                />
            </label>
            <div *ngIf="submitted && (f.newPassword.errors || showMessage)" class="invalid-feedback">
                <div
                    *ngIf="f.newPassword.errors && f.newPassword.errors.required"
                    [innerHTML]="translationPrefix + '.newPasswordRequired' | translate"
                ></div>
                <div
                    *ngIf="f.newPassword.errors && f.newPassword.errors.pattern"
                    [innerHTML]="translationPrefix + '.mustMatchPatter' | translate"
                ></div>
            </div>
        </div>

        <div
            class="form-group"
            [class.active]="hasFocusRenewPassword || hasValue(f.renewPassword)"
            [class.hasvalue]="!hasFocusRenewPassword && hasValue(f.renewPassword)"
        >
            <label
                for="renewPassword"
                [class.active]="hasFocusRenewPassword || hasValue(f.renewPassword)"
                [class.hasvalue]="!hasFocusRenewPassword && hasValue(f.renewPassword)"
            >
                <span class="labelcontent"><span [innerHTML]="translationPrefix + '.renewPassword' | translate"></span></span>
                <input
                    formControlName="renewPassword"
                    id="renewPassword"
                    (focus)="hasFocusRenewPassword = true"
                    (blur)="hasFocusRenewPassword = false"
                    type="password"
                />
            </label>
            <div *ngIf="submitted && (f.renewPassword.errors || showMessage)" class="invalid-feedback">
                <div
                    *ngIf="f.renewPassword.errors && f.renewPassword.errors.required"
                    [innerHTML]="translationPrefix + '.renewPasswordRequired' | translate"
                ></div>
                <div
                    *ngIf="f.renewPassword.errors && f.renewPassword.errors.mustMatch"
                    [innerHTML]="translationPrefix + '.mustMatch' | translate"
                ></div>
            </div>
        </div>
        <div class="legend" [innerHTML]="translationPrefix + '.legend' | translate"></div>

        <div class="button-wrapper">
            <a [routerLink]="linkPersonalData" class="secondary button" da-link
                ><span [innerHTML]="'forgotPassword.cancel' | translate"></span
            ></a>
            <button [disabled]="loaded$ | async" class="button primary">
                <span [innerHTML]="'forgotPassword.submit' | translate"></span>
            </button>
        </div>
        <div *ngIf="showMessage" class="error-message" [innerHTML]="translationPrefix + '.serverErrorMessage' | translate"></div>
    </div>
</form>
<ng-container *ngIf="success">
    <div class="success">
        <h1 [innerHTML]="translationPrefix + '.titleSuccess' | translate"></h1>
        <p class="large" [innerHTML]="translationPrefix + '.messageSuccess' | translate"></p>
        <div class="button-wrapper">
            <a [routerLink]="linkPersonalData" class="secondary button" da-link
                ><span [innerHTML]="'forgotPassword.backToPersonalData' | translate"></span
            ></a>
        </div>
    </div>
</ng-container>
